import { render, staticRenderFns } from "./HighlightStatsCustomer.vue?vue&type=template&id=39ce6a7e&scoped=true&"
import script from "./HighlightStatsCustomer.vue?vue&type=script&lang=js&"
export * from "./HighlightStatsCustomer.vue?vue&type=script&lang=js&"
import style0 from "./HighlightStatsCustomer.vue?vue&type=style&index=0&id=39ce6a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce6a7e",
  null
  
)

export default component.exports